var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn && _vm.toggleSidebar)?_c('aside-nav'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('notifications'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading__image",attrs:{"src":"/static/img/waiting.gif","alt":""}})]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da447222","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 